import React from 'react'
import Skeleton from 'react-loading-skeleton'
import './style.css'
export default function loader_detail_event() {
    return (
        <div>
            <div className='loader-desktop' >
                <div style={{display:'flex'}}>
                    <div style={{width:400}}>
                        <Skeleton height={200}/>
                    </div>
                    &nbsp;&nbsp;
                    <div style={{width:700}}>
                        <br/>
                        <div style={{width:400}}>
                            <Skeleton height={30}/>

                        </div>
                        <br/><br/><br/>
                        <div style={{width:300}}>
                            <Skeleton height={30}/>

                        </div>
                        
                        
                    </div>
                </div>
                <br/>
                <div style={{display:'flex'}}>
                    <div style={{width:700}}>
                    <Skeleton height={30}/>
                    <br/><br/>
                    <Skeleton height={200}/>

                    </div>
                    &nbsp;&nbsp;
                    <div style={{width:400}}>
                    <Skeleton height={270}/>

                    </div>
                </div>
            </div>
            <div className='loader-mobile'>
                <Skeleton height={200}/>
                <br/><br/>
                <div style={{width:200}}>
                <Skeleton height={30}/>
                </div>
                <br/>
                <Skeleton height={80}/>
                <br/><br/>

                <Skeleton height={150}/>
            </div>
        </div>
    )
}
